import { KEEP_LOGGED_LS_KEY, LIVIA_LS_KEY } from 'constants/app'
import { EMPTY_DATA_USER } from 'constants/singin'
import { UserToken } from 'typings/auth'

type Token = string | null | undefined

export const getUserToken = async () => Promise.resolve().then(() => JSON.parse(localStorage.getItem(LIVIA_LS_KEY)!))

export const getkeepLoggedLs = async () => Promise.resolve().then(() => JSON.parse(localStorage.getItem(KEEP_LOGGED_LS_KEY)!))

export const setUserToken = (value: UserToken) => localStorage.setItem(LIVIA_LS_KEY, JSON.stringify(value))

export const setkeepLoggedLs = (value: UserToken) => localStorage.setItem(KEEP_LOGGED_LS_KEY, JSON.stringify(value))

export const removeUserToken = async () =>
    Promise.resolve().then(() => localStorage.setItem(LIVIA_LS_KEY, JSON.stringify(EMPTY_DATA_USER)))

export const addUserToken = async (accessToken: Token, refreshToken: Token) => {
    const actualStorage = await getUserToken()
    localStorage.setItem(
        LIVIA_LS_KEY,
        JSON.stringify({
            token: accessToken,
            refreshToken: refreshToken,
            signed: !!accessToken,
            redesign: actualStorage?.redesign,
            keepLogged: actualStorage?.keepLogged,
        }),
    )
}
